import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Article from "../../../entities/Article";
import { ArticleService } from "../../../service/articleDelivery/ArticleService";

class ArticleTransactionsStore {

    public articleId: string;
    public article: Article;
    public isModalOpen: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, articleId: string) {
        this.articleId = articleId;
        this.isModalOpen = false;
        this.article = {} as Article;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
        public async loadArticle() {
        const response = await ArticleService.find(this.articleId!)
        if (response.success && response.data) {
            this.article = response.data;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        await this.loadArticle();
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

}

export default ArticleTransactionsStore;